import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Erstelle das Theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // Google Blau
    },
    secondary: {
      main: '#90caf9', // Hellblau
    },
    warning: {
      main: '#ed6c02', // Orange
    },
    error: {
      main: '#d32f2f', // Rot
    },
    success: {
      main: '#2e7d32', // Grün
    },
    info: {
      main: '#0288d1', // Blau
    },
    background: {
      default: '#fafafa', // Helles Grau
    },
    text: {
      primary: '#424242', // Dunkelgrau
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif', // Hauptschriftart
    h1: {
      fontFamily: 'Roboto Slab, serif', // Schriftart für H1
      fontWeight: 700,
    },
    h2: {
      fontFamily: 'Roboto Slab, serif', // Schriftart für H2
      fontWeight: 700,
    },
    h3: {
      fontFamily: 'Roboto Slab, serif', // Schriftart für H3
      fontWeight: 700,
    },
    h4: {
      fontFamily: 'Roboto Slab, serif', // Schriftart für H4
      fontWeight: 700,
    },
    h5: {
      fontFamily: 'Roboto Slab, serif', // Schriftart für H5
      fontWeight: 700,
    },
    h6: {
      fontFamily: 'Roboto Slab, serif', // Schriftart für H6
      fontWeight: 700,
    },
    body1: {
      fontSize: '16px',
    },
    body2: {
      fontSize: '14px',
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <GoogleOAuthProvider clientId="898015681497-6qlole7k98t0kn1b4ici8ckm37eksouq.apps.googleusercontent.com">
        <ThemeProvider theme={theme}>
          <CssBaseline /> {/* Fügt Standard-CSS hinzu */}
          <App />
        </ThemeProvider>
      </GoogleOAuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
